export default "__VITE_ASSET__HkH2FKPr__"